import {SOPutPaymentIntent} from '../../core/payment-intent/so-put-payment-intent';
import {PaymentIntentCore} from './payment-intent.core';
import {SOGetPaymentIntent} from '../../core/payment-intent/so-get-payment-intent';
import {FormField, SelectionOption} from 'lionheartland';
import {putPaymentIntentFormFieldOptions} from './put-payment-intent-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePut} from 'lionheartland';
import {InvoiceCore} from '../invoice/invoice.core';
import {SOGetInvoice} from '../../core/invoice/so-get-invoice';

export class RAPutPaymentIntent extends BasePut implements AdapterProtocol {
  formFieldOptions = Object.values(putPaymentIntentFormFieldOptions);

  RequestClass = SOPutPaymentIntent

  constructor(
    public entityCore: PaymentIntentCore
  ) {
    super();
    if (putPaymentIntentFormFieldOptions.invoice) {
      putPaymentIntentFormFieldOptions.invoice.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.selectedEntity.uid,
      this.getFormValueFromIdentifier('amount'),
      this.getFormValueFromIdentifier('status'),
      this.getFormValueFromIdentifier(
        'invoice',
        SOGetInvoice,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}